/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_ButtonInputs */



/**
* | output |
* | --- |
* | "Sign in with a passkey" |
*
* @param {Portalsignin_Passkey_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_button = /** @type {((inputs?: Portalsignin_Passkey_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sign in with a passkey")
});